import { jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';

@jsonObject
export class AdminCosmeticCharacteristicRequest {
  @jsonMember(String)
  public readonly label!: string;

  @jsonMember(String)
  public readonly value!: string;

  @jsonMember(String)
  public readonly id?: Nillable<Guid>;

  public constructor(
    private readonly data: {
      id?: Nillable<Guid>;
      label: string;
      value: string;
    },
  ) {
    this.id = data.id;
    this.label = data.label;
    this.value = data.value;
  }
}
